import { Box, Modal } from "@mui/material";

interface LoaderProps {
  isLoad?: boolean;
  isLoading?: boolean;
}

const Loader = (props: LoaderProps) => {
  const style = {
    outline: "none",
  };
  return (
    <Box>
      {(props.isLoad || props.isLoading) ? (
        <Modal open>
          <Box className="loader_loading" sx={style}>
            <figure>
              <img src="/static/images/loader.gif" alt="loading" />
            </figure>
          </Box>
        </Modal>
      ) : (
        ""
      )}
    </Box>
  );
};

export default Loader;
